import { Spinner } from 'react-bootstrap';

export const StandardLoader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center my-5">
      <Spinner animation="border" variant="danger" />
    </div>
  );
};
